// Russian — scripts/translate-locale.mjs 로 생성 (en.js 기준).
// 손으로 고친 값은 다음 실행에서 덮이지 않는다 (--force 제외).
// 자리표시자({n} 등)가 어긋난 항목은 영어를 그대로 둔다.
export const ru = {
  "uploadTitle": "Загрузи фото",
  "uploadHint": "Нажми или перетащи фото сюда",
  "uploadHintTouch": "Нажми, чтобы выбрать фото",
  "uploadOr": "или",
  "takePhoto": "Сделать фото",
  "yourPhotos": "Твои фото",
  "photoLabel": "Фото {n}",
  "photoCount": "{n} фото",
  "addPhoto": "Добавить фото",
  "continue": "Продолжить",
  "stepLabel": "Шаг {current} из {total}",
  "chooseStyle": "Выбери стиль дизайна",
  "describeCustomStyle": "Опиши свой стиль",
  "uploadReferenceTitle": "Загрузи референс",
  "uploadReferenceHint": "ИИ подберет цвета, материалы и настроение, а планировка твоей комнаты не изменится.",
  "removeReference": "Удалить референс",
  "cleanupOptionTidy": "Навести порядок",
  "cleanupOptionTidyDesc": "Оставить мебель, убрать беспорядок, мусор и лишние вещи",
  "cleanupOptionEmpty": "Освободить комнату",
  "cleanupOptionEmptyDesc": "Убрать всю мебель и декор. Стены и пол останутся",
  "cleanupChooseOption": "Выбери режим уборки",
  "layoutOptionFlow": "Удобный проход",
  "layoutOptionFlowDesc": "Улучшает проходы — станет легче передвигаться",
  "layoutOptionSpacious": "Больше простора",
  "layoutOptionSpaciousDesc": "Убирает визуальный шум — комната кажется просторнее",
  "planChooseOption": "Что сделать из твоей планировки?",
  "planOption_3d": "3D-план",
  "planOption_3dDesc": "Весь дом сверху с мебелью в нужном стиле",
  "planOption_room": "Одна комната",
  "planOption_roomDesc": "Закрась комнату на плане и увидишь её на уровне глаз",
  "planOption_clean": "Перерисовать план",
  "planOption_cleanDesc": "Эскиз или размытый план, аккуратно перерисованный",
  "planCleanKindTitle": "Тип чертежа",
  "planCleanKind_line": "Черно-белый",
  "planCleanKind_color": "Цветной план",
  "planStyleTitle": "Стиль",
  "planRoomTitle": "Какая комната?",
  "planRoomSignIn": "Войди, чтобы выбрать комнату на плане.",
  "planRoomPaint": "Закрась комнату на плане",
  "planRoomPicked": "Комната выбрана",
  "planRoomRepaint": "Закрасить снова",
  "planRoomClear": "Сбросить",
  "planRoomNamePlaceholder": "Или введи название комнаты (напр., спальня)",
  "planCropHint": "Обрежь фото по краям плана — так результат будет точнее.",
  "planFirstOnly": "Для плана используется только первое фото.",
  "planRoomPickTitle": "Выбери комнату",
  "planRoomPickHint": "Закрась нужную комнату. Достаточно сделать это примерно.",
  "planRoomPickDone": "Использовать эту комнату",
  "planRoomNeedPick": "Закрась комнату на плане или введи её название.",
  "errNotFloorplan": "Это не похоже на планировку. Загрузи планировку или выбери стиль.",
  "planRoomFrom": "Комната, выбранная на плане",
  "planInputLabel": "Планировка",
  "planOutput_plan_3d": "3D-план",
  "planOutput_plan_room": "Вид комнаты",
  "planOutput_plan_clean": "Чистовой план",
  "planOutput_plan_color": "Цветной план",
  "planRoomFromResult": "Посмотреть комнату",
  "planRoomMake": "Создать эту комнату",
  "planRoomMeta": "{n} кредитов · эта комната на уровне глаз, тот же дом",
  "layoutChooseOption": "Выбери вариант перестановки",
  "creditEarnHint": "Получай кредиты за ежедневный вход (+1) или приглашение друзей (+5 за каждого).",
  "languageHint": "Также используется для анализа дизайна.",
  "reuseStyle": "— Использовать прошлый стиль —",
  "customPlaceholder": "Опиши желаемый стиль (например, «уютный домик в теплых деревянных тонах» или «футуристичный минимализм с металлом»)",
  "customStylePublicHint": "Текст твоего стиля может анонимно появиться в сообществе. Это можно отключить в настройках аккаунта.",
  "communityRankTitle": "Популярные стили",
  "communityPeople": "Применили: {n}",
  "customStylesChip": "Свои стили",
  "galleryRecentBadge": "Только что",
  "timeJustNow": "только что",
  "timeAgoMin": "{n} мин. назад",
  "timeAgoHour": "{n} ч. назад",
  "communityViewAll": "Посмотреть все",
  "galleryTitle": "Популярные стили",
  "briefsLabel": "Новости",
  "briefTopupKicker": "Кредиты",
  "briefTopupTitle": "Не хватает кредитов на следующий дизайн",
  "briefTopupLine": "Бесплатные кредиты пополнятся завтра. Нужно больше сейчас? Купи набор.",
  "briefSeasonKicker": "В сезоне",
  "briefSeasonTitle": "{name} уже здесь",
  "briefSeasonLine": "Сезонный стиль — всего на несколько недель.",
  "briefInviteKicker": "Приглашение",
  "briefInviteTitle": "Пригласи друга — вы оба получите +{n} кредитов",
  "briefInviteLine": "Поделись ссылкой. Кредиты придут после регистрации.",
  "galleryEmpty": "Здесь пока нет трендов — стили появятся, когда их начнут использовать.",
  "galleryBuiltinTitle": "Рейтинг стилей за последнее время",
  "galleryPopularCustom": "Популярные свои стили за последнее время",
  "galleryDiscoverTitle": "Обзор своих стилей",
  "galleryShuffle": "Перемешать",
  "galleryTranslate": "Перевести",
  "galleryTranslating": "Перевод…",
  "galleryOriginal": "Показать оригинал",
  "galleryLiveTab": "В эфире",
  "galleryLiveWaiting": "Ожидание новых стилей…",
  "galleryLiveTitle": "Используют прямо сейчас",
  "galleryRecentCustom": "Недавние свои стили",
  "galleryUse": "Использовать стиль",
  "styleShareNotice": "Текст твоего стиля может анонимно появиться в сообществе.",
  "styleShareNoticeSettings": "Отключить в настройках",
  "styleShareNoticeOk": "Понятно",
  "communityTopTitle": "Популярные свои стили",
  "communityRecentTitle": "Недавно созданные",
  "communityUses": "Использовано {n} раз",
  "communityDesigns": "Дизайнов: {n}",
  "communityDesignsOne": "Дизайнов: {n}",
  "styleShareTitle": "Поделись своими стилями",
  "styleShareDesc": "Позволь другим находить и пробовать твои стили. Твои фото никогда не публикуются.",
  "additionalRequests": "Дополнительные пожелания",
  "optional": "(необязательно)",
  "additionalPlaceholder": "Что-то конкретное для стиля {style}? (например, «добавить деревянный столик», «бирюзовый акцент»)",
  "addAdditionalRequest": "+ Добавить пожелания",
  "generateDesign": "Создать дизайн",
  "back": "Назад",
  "generatingOne": "ИИ создает твой дизайн интерьера…",
  "generatingMany": "ИИ создает {n} гармоничных дизайнов для твоей комнаты…",
  "generatingOneExterior": "ИИ создает новый экстерьер…",
  "generatingManyExterior": "ИИ создает {n} гармоничных рендеров экстерьера…",
  "generatingOneGarden": "ИИ создает дизайн твоего сада…",
  "generatingManyGarden": "ИИ создает {n} гармоничных рендеров сада…",
  "generationFailed": "Не удалось создать",
  "tryAgain": "Попробовать еще раз",
  "errNoInternet": "Нет интернета. Проверь подключение и попробуй еще раз.",
  "errTimeout": "ИИ отвечает слишком долго. Попробуй еще раз.",
  "errTooMany": "Слишком много запросов. Подожди немного и попробуй еще раз.",
  "errNetwork": "Ошибка сети. Проверь подключение и попробуй еще раз.",
  "errAI": "Произошел сбой ИИ-сервиса. Попробуй еще раз.",
  "errFileType": "Неподдерживаемый тип файла. Загрузи изображение JPEG, PNG или WebP.",
  "errFileTooLarge": "Файл слишком большой. Загрузи изображение до 20 МБ.",
  "errPhotoRead": "Не удалось прочитать фото. Попробуй другое.",
  "errCameraAccess": "Нет доступа к камере. Разреши доступ в Настройках.",
  "errCameraCapture": "Не удалось сделать фото. Попробуй еще раз.",
  "errCaptionSave": "Не удалось сохранить подпись. Попробуй еще раз.",
  "imageUnavailable": "Изображение недоступно",
  "designShareText": "Посмотри этот дизайн в стиле {style}, созданный в archelier",
  "altPhoto": "Фото {n}",
  "altOriginal": "Оригинал {n}",
  "altGenerated": "Дизайн {n}",
  "errInvalidSpace": "Не удалось распознать комнату. Нужен снимок, где видны стена и пол или угол комнаты.",
  "pickAnotherPhoto": "Выбрать другое фото",
  "errCustomStyle": "Опиши свой стиль.",
  "errSignIn": "Не удалось войти. Попробуй еще раз.",
  "errInsufficientCredits": "Кредиты закончились. Возвращайся завтра за ежедневным бонусом.",
  "creditCostHint": "{n} фото — это {c} кредитов ({p} за фото).",
  "errCreditsShort": "Нужно {need} кредитов, а у тебя {have}. Убери фото или пригласи друга.",
  "credits": "Кредиты",
  "creditsOne": "{n} кредит",
  "creditsMany": "{n} кредитов",
  "outOfCredits": "Кредиты закончились",
  "creditModalTitle": "Получить еще кредиты",
  "creditModalDesc": "Твои ежедневные кредиты обновятся завтра. Хочешь еще прямо сейчас?",
  "creditModalWallDesc": "Бесплатные дизайны на сегодня закончились. Завтра появится еще {n} — или пополни баланс и продолжай.",
  "errOutOfCreditsToday": "У тебя закончились кредиты на сегодня. Завтра вернутся {n} бесплатных — или пополни баланс, чтобы продолжить.",
  "lastFreeHint": "Это был последний бесплатный дизайн на сегодня. Завтра будет еще {n}.",
  "lastFreeHintCta": "Пополнить сейчас",
  "creditModalChatFree": "Чат с Gio, твоим дизайнером, остаётся бесплатным.",
  "creditModalGuestTitle": "Войди, чтобы продолжить",
  "creditModalGuestDesc": "После входа ты будешь получать бесплатные кредиты каждый день, сможешь сохранять проекты и делиться ими.",
  "creditOptionSignIn": "Войти и продолжить",
  "creditOptionSignInDesc": "Быстрый вход через Google или Apple",
  "creditOptionInvite": "Пригласить друга",
  "creditOptionInviteDesc": "Вы оба получите +{n} кредитов после регистрации",
  "comingSoon": "Скоро появится",
  "close": "Закрыть",
  "getAppTitle": "archelier",
  "getAppDesc": "Меняй своё пространство в приложении",
  "getAppCta": "Получить",
  "appGateTitle": "Продолжить в приложении",
  "appGateDesc": "В приложении удобнее: камера, сохранённые дизайны и более быстрый результат.",
  "appGateCta": "Установить приложение",
  "appGateNotNow": "Не сейчас",
  "dailyBonusHint": "Ты получаешь {n} бесплатных кредитов каждый день.",
  "creditsAria": "Осталось кредитов: {n}",
  "accountCreditsTitle": "Кредиты",
  "creditsDailyLabel": "Ежедневные, обновляются в полночь",
  "creditsBonusLabel": "Бонусные, не сгорают",
  "creditsResetHint": "Ты получаешь {n} бесплатных кредитов каждый день. Бонусы за приглашения не сгорают.",
  "creditsInviteCta": "Пригласить друга за +{n}",
  "creditsTopUpCta": "Купить кредиты",
  "inviteMenu": "Пригласить друзей",
  "profileShare": "Поделиться",
  "profileShareText": "Посмотри на дизайны от {name} в archelier.",
  "original": "Оригинал",
  "aiDesign": "Дизайн ИИ",
  "imageGenFailed": "Не удалось создать изображение для этого фото",
  "seeAnalysis": "Смотри анализ дизайна ниже.",
  "analysisTitle": "Анализ дизайна интерьера",
  "spaceAnalysis": "Анализ пространства",
  "styleDescription": "Описание стиля",
  "colorPalette": "Цветовая палитра",
  "furnitureRec": "Рекомендации по мебели",
  "shopFor": "Купить {item}",
  "shopShort": "Магазин",
  "paintMatch": "Похожая краска",
  "paintCodeCopy": "Копировать код краски",
  "paintCodeCopied": "Код скопирован",
  "editRegion": "Изменить область",
  "editRegionTitle": "Изменить дизайн",
  "editRegionDesc": "Укажи ИИ, что изменить и что поставить взамен. Остальная часть комнаты останется прежней.",
  "editRegionBrushHint": "Расскажи ИИ, что изменить или добавить. Чтобы обновить одну деталь, сначала выдели её кистью — иначе изменится всё фото. Чтобы что-то удалить, закрась это и напиши «удали».",
  "editRegionMeta": "Сохранено как новый дизайн · {n} кредитов",
  "editedFromBanner": "Это измененная копия.",
  "viewOriginal": "Посмотреть оригинал",
  "editsOfThisDesign": "Версии этого дизайна",
  "editsOfThisDesignDesc": "Дизайны, созданные тобой на основе этого.",
  "chatTitle": "ИИ-консультант",
  "chatHint": "Задавай вопросы об этой комнате. ИИ видит твой дизайн и опирается на него.",
  "chatStart": "Начать чат",
  "chatPlaceholder": "Спроси про мебель, цвет или планировку…",
  "chatSend": "Отправить",
  "chatSending": "Думает…",
  "chatSuggestion1": "Какая лампа сделает комнату уютнее?",
  "chatSuggestion2": "Как сделать это пространство просторнее?",
  "chatSuggestion3": "Какие 3 вещи стоит изменить в первую очередь?",
  "chatTurnsRemaining": "Осталось {n} вопросов для этого дизайна",
  "chatTurnsExhausted": "Лимит чата для этого дизайна исчерпан. Создай новый дизайн, чтобы продолжить.",
  "chatErrGeneric": "Консультант не смог ответить. Попробуй еще раз.",
  "chatPro": "Pro — безлимитный чат",
  "chatRetry": "Повторить",
  "commentsTitle": "Комментарии",
  "commentPlaceholder": "Написать комментарий...",
  "commentPost": "Опубликовать",
  "commentPosting": "Публикация…",
  "commentSignInHint": "Войди в аккаунт, чтобы оставить комментарий.",
  "commentEmpty": "Комментариев пока нет.",
  "commentDelete": "Удалить",
  "commentDeleteConfirm": "Удалить этот комментарий?",
  "commentTooLong": "Длина комментария — не более 500 символов.",
  "commentErrGeneric": "Не удалось опубликовать комментарий. Попробуй еще раз.",
  "commentCount": "{n}",
  "bookmarksTitle": "Мои коллекции",
  "tabDesigns": "Дизайны",
  "tabCollections": "Коллекции",
  "bookmarksSectionTitle": "Сохраненные дизайны",
  "bookmarksEmpty": "Коллекций пока нет. Сохрани любой дизайн, чтобы создать доску.",
  "bookmarksAdd": "Сохранить",
  "bookmarksAdded": "Сохранено",
  "bookmarksRemove": "Удалить из сохраненных",
  "bookmarksSignInHint": "Войди в аккаунт, чтобы сохранять дизайны.",
  "saved": "Сохранено",
  "savedCollectionDefault": "Сохраненное",
  "follow": "Подписаться",
  "unfollow": "Отписаться",
  "following": "Подписки",
  "followers": "Подписчики",
  "followingTab": "Подписки",
  "followingEmpty": "Подпишись на авторов, чтобы видеть их новые дизайны здесь.",
  "followersEmpty": "Подписчиков пока нет.",
  "followingEmpty2": "Ты пока ни на кого не подписался.",
  "followSignInHint": "Войди в аккаунт, чтобы подписаться",
  "cannotFollowSelf": "Нельзя подписаться на самого себя.",
  "profile": "Профиль",
  "profileNotFound": "Этот профиль не существует.",
  "profileDesigns": "Дизайны",
  "profileDesignsCount": "Проекты",
  "profileFollowers": "Подписчики",
  "profileFollowing": "Подписки",
  "profileBio": "О себе",
  "profileEdit": "Редактировать профиль",
  "profileMyProfile": "Мой профиль",
  "displayNameLabel": "Имя",
  "displayNamePlaceholder": "Твое имя или студия (необязательно)",
  "displayNameSave": "Сохранить имя",
  "displayNameSaved": "Имя сохранено",
  "displayNameErrGeneric": "Не удалось сохранить имя. Попробуй еще раз.",
  "handleLabel": "Никнейм",
  "handlePlaceholder": "строчные буквы, цифры, подчеркивание (3–20 симв.)",
  "handleSave": "Сохранить никнейм",
  "handleSaved": "Никнейм сохранен",
  "handleInvalid": "Никнейм должен быть от 3 до 20 симв.: a-z, 0-9, подчеркивание.",
  "handleTaken": "Этот никнейм уже занят.",
  "handleErrGeneric": "Не удалось сохранить никнейм. Попробуй еще раз.",
  "bioPlaceholder": "Расскажи немного о себе (макс. 200 симв.)",
  "bioSave": "Сохранить",
  "bioSaved": "Описание сохранено",
  "bioErrGeneric": "Не удалось сохранить описание. Попробуй еще раз.",
  "instagramLabel": "Instagram",
  "instagramPlaceholder": "твой_ник_в_instagram",
  "instagramInvalid": "Только буквы, цифры, точка или подчеркивание (макс. 30).",
  "profileNoDesigns": "Проектов пока нет.",
  "collections": "Коллекции",
  "collectionsTab": "Коллекции",
  "collectionMine": "Мои коллекции",
  "collectionEmpty": "Коллекций пока нет.",
  "collectionPublicEmpty": "Нет публичных коллекций.",
  "collectionItemCount": "{n} элементов",
  "collectionEmpty2": "Эта коллекция пуста.",
  "newCollection": "Новая коллекция",
  "collectionNamePlaceholder": "Название (например, Идеи для гостиной)",
  "collectionCreate": "Создать",
  "collectionDelete": "Удалить коллекцию",
  "collectionDeleteConfirm": "Удалить эту коллекцию? Содержимое будет удалено.",
  "collectionRename": "Переименовать",
  "collectionVisibility": "Публичная коллекция",
  "collectionVisibilityOn": "Доступно всем по ссылке",
  "collectionVisibilityOff": "Видно только тебе",
  "addToCollection": "Добавить в коллекцию",
  "saveToCollection": "Сохранить в коллекцию",
  "collectionAdded": "Добавлено",
  "collectionRemoveFromBoard": "Удалить из коллекции",
  "collectionShareLink": "Скопировать ссылку",
  "collectionByOwner": "от",
  "collectionNotFound": "Коллекция не найдена или она приватная.",
  "collectionErrCreate": "Не удалось создать коллекцию.",
  "collectionErrSave": "Не удалось обновить коллекцию.",
  "collectionDone": "Готово",
  "collectionPickerHint": "Нажми на коллекцию, чтобы добавить или удалить проект.",
  "uploadAcceptsHint": "Лучше всего подходят фото, но эскизы, развертки, планировки и 3D-скриншоты тоже подойдут.",
  "examplePhotos": "Примеры фото",
  "detectedInputTypes": {
    "sketch": "Эскиз",
    "elevation": "Развертка",
    "floorplan": "Планировка",
    "3d_model": "3D-модель"
  },
  "floorplanDetectedBanner": "Похоже на планировку — мы визуализировали самую большую общую комнату на уровне глаз. Чтобы выбрать конкретную комнату, в следующий раз добавь примечание к запросу (например, «визуализировать спальню»).",
  "floorplanDetectedBannerWithRoom": "Похоже на планировку — визуализировали {room} на уровне глаз. Чтобы выбрать другую комнату, добавь примечание к запросу в следующий раз.",
  "spaceCategoryTitle": "Что ты проектируешь?",
  "spaceCategories": {
    "interior": "Интерьер",
    "exterior": "Экстерьер",
    "garden": "Сад"
  },
  "exteriorStyles": {
    "halloween": {
      "name": "Хэллоуин",
      "description": "Тыквы, фонари, осеннее крыльцо"
    },
    "christmas": {
      "name": "Рождество",
      "description": "Венки, тёплые гирлянды, еловый декор"
    },
    "lunar_new_year": {
      "name": "Лунный Новый год",
      "description": "Красные фонари, золото, благопожелания"
    },
    "spring_blossom": {
      "name": "Весеннее цветение",
      "description": "Цветущие деревья, пастельные клумбы, свет"
    },
    "modern_facade": {
      "name": "Современный фасад",
      "description": "Четкая геометрия, панорамные окна, разные материалы"
    },
    "modern_farmhouse": {
      "name": "Современный фармхаус",
      "description": "Белый сайдинг, черная отделка, акценты из дерева"
    },
    "mediterranean": {
      "name": "Средиземноморский",
      "description": "Штукатурка, терракота, арочные проемы"
    },
    "craftsman": {
      "name": "Крафтсман",
      "description": "Деревянный гонт, пологие фронтоны, открытые стропила"
    },
    "contemporary": {
      "name": "Контемпорари",
      "description": "Четкие линии, смелые объемы, индустриальные материалы"
    },
    "minimalist_exterior": {
      "name": "Минималистичный экстерьер",
      "description": "Сдержанная палитра, акцент на одном материале"
    },
    "tudor": {
      "name": "Тюдор",
      "description": "Английский тюдоровский стиль — фахверк и крутые крыши"
    },
    "cape_cod": {
      "name": "Кейп-Код",
      "description": "Традиции Новой Англии — белый гонт и черные ставни"
    },
    "japanese_traditional": {
      "name": "Традиционный японский",
      "description": "Деревянный каркас минка, черепица и терраса энгава"
    },
    "mountain_cabin": {
      "name": "Горный домик",
      "description": "А-образный дом или сруб в окружении природы"
    },
    "midcentury_exterior": {
      "name": "Мид-сенчури экстерьер",
      "description": "Модернизм 50–60-х: плоская крыша, панорамные окна, горизонтальные линии"
    }
  },
  "gardenStyles": {
    "halloween": {
      "name": "Хэллоуин",
      "description": "Тыквы, фонари, туманный осенний сад"
    },
    "christmas": {
      "name": "Рождество",
      "description": "Подсвеченные ели, тёплый свет, зимний сад"
    },
    "lunar_new_year": {
      "name": "Лунный Новый год",
      "description": "Красные фонари, цветущие ветви, сад"
    },
    "spring_blossom": {
      "name": "Весеннее цветение",
      "description": "Сакура, тюльпаны, весенняя зелень"
    },
    "modern": {
      "name": "Современный сад",
      "description": "Строгая геометрия, бетонные плиты, декоративные злаки"
    },
    "mediterranean": {
      "name": "Средиземноморский",
      "description": "Гравий, олива и лаванда, терракотовые горшки, пергола"
    },
    "coastal": {
      "name": "Прибрежный",
      "description": "Травы, коряги, солеустойчивые растения"
    },
    "minimalist": {
      "name": "Минимализм",
      "description": "Один материал, минимум видов растений, свободное пространство"
    },
    "zen": {
      "name": "Дзен-сад",
      "description": "Гравий с узорами, камни, редкие растения"
    },
    "cottage": {
      "name": "Коттеджный сад",
      "description": "Романтичные густые посадки, смесь многолетников"
    },
    "desert": {
      "name": "Пустынный / Ксерискейп",
      "description": "Засухоустойчивые растения, суккуленты, гравий"
    },
    "tropical": {
      "name": "Тропический",
      "description": "Пышная зелень, крупные листья, яркие цветы"
    },
    "english": {
      "name": "Английский сад",
      "description": "Ухоженный газон, живые изгороди, многоярусные клумбы"
    }
  },
  "seasonLabel": "Сезон",
  "seasons": {
    "none": "Любой",
    "spring": "Весна",
    "summer": "Лето",
    "autumn": "Осень",
    "winter": "Зима"
  },
  "timeOfDayLabel": "Время суток",
  "timesOfDay": {
    "none": "Любое",
    "day": "День",
    "golden_hour": "Золотой час",
    "night": "Ночь"
  },
  "editRegionReplacementLabel": "Что изменить?",
  "editRegionReplacementPlaceholder": "например, добавить большую статую у входа",
  "editRegionSubmit": "Изменить",
  "editRegionGenerating": "Генерируем изменения…",
  "editRegionMaskRequired": "Сначала закрась область, которую хочешь изменить.",
  "editRegionReplacementRequired": "Напиши, что туда добавить.",
  "editRegionBrush": "Кисть",
  "editRegionUndo": "Отменить",
  "editRegionSize": "Размер",
  "editRegionClear": "Сбросить",
  "errEditGeneric": "Не удалось изменить. Попробуй еще раз.",
  "lightingPlan": "План освещения",
  "designTips": "Советы по дизайну",
  "startNew": "Новый дизайн",
  "viewMyDesigns": "Мои дизайны",
  "favorite": "В избранное",
  "unfavorite": "Убрать из избранного",
  "rename": "Переименовать",
  "savePromptText": "Войди, чтобы сохранить этот дизайн, поделиться им и создавать новые",
  "guestCreditsLeft": "Остался всего {n} бесплатный дизайн. Войди и начни с {total}.",
  "guestCreditsGone": "Это был твой последний бесплатный дизайн. Войди и получи {total}.",
  "signInGoogle": "Войти через Google",
  "signInApple": "Войти через Apple",
  "signInDesc": "Сохраняй свои дизайны и открывай их в любое время.",
  "signInPopupBlocked": "Всплывающее окно заблокировано. Разреши всплывающие окна в настройках браузера.",
  "appName": "archelier",
  "navCreate": "Создать",
  "navGallery": "Галерея",
  "navGio": "Дизайнер",
  "navMain": "Главная навигация",
  "packsTitle": "Пополнить",
  "packDesigns": "около {n} дизайнов",
  "packBuying": "Открываем…",
  "packWaiting": "Оплата прошла — начисляем кредиты…",
  "packDone": "Кредиты начислены.",
  "packSlow": "Кредиты уже в пути. Они скоро появятся, повторно покупать не нужно.",
  "packFailed": "Покупка не прошла. Если деньги списались, а кредиты не пришли, напиши в поддержку.",
  "gioRole": "Дизайнер интерьера",
  "gioAiNote": "ИИ",
  "gioSignInBody": "Войди, чтобы общаться с Gio. Он смотрит на фото комнаты и твои дизайны, предлагает стили и может сразу в чате создать или изменить проект.",
  "gioGreeting": "Привет, я Gio. Отправь фото комнаты, ссылку на интерьер или свой дизайн — я подскажу стиль и сделаю проект.",
  "gioChipTaste": "Какой у меня вкус?",
  "gioChipTrend": "Что в тренде на этой неделе?",
  "gioChipPhoto": "Отправить фото комнаты",
  "gioChipMine": "Взять один из моих дизайнов",
  "gioTyping": "Gio думает…",
  "gioPlaceholder": "Спроси Gio или вставь ссылку",
  "gioSend": "Отправить",
  "gioAttachPhoto": "Прикрепить фото",
  "gioPickDesign": "Мои дизайны",
  "gioPickEmpty": "Дизайнов пока нет — сначала создай один, а потом добавь сюда.",
  "gioRemove": "Удалить",
  "gioToday": "Сегодня",
  "gioNoCredits": "Кредиты закончились.",
  "gioError": "Gio не смог ответить. Попробуй ещё раз.",
  "gioAlreadyStarting": "Уже начинаю — подожди немного.",
  "gioPhotoSkipped": "Некоторые фото не добавились. Можно прикрепить до {n} фото (JPG, PNG, WebP или HEIC, до 20 МБ).",
  "gioErrPhotos": "Не удалось найти фото. Добавь фото своего пространства и попробуй снова.",
  "gioErrPrompt": "Gio не удалось превратить это в дизайн. Попробуй описать иначе.",
  "gioErrGone": "Этот дизайн или вариант больше недоступны.",
  "gioCreditsLow": "Осталось {n} кредитов · сообщение: {c}, с фото: {p}",
  "gioCreditsLowFree": "Осталось {n} кредитов · чат с Gio бесплатный",
  "gioNoCreditsChatFree": "Кредиты на дизайн закончились — чат остаётся бесплатным.",
  "gioDailyLimit": "На сегодня мы много пообщались. Продолжим завтра.",
  "gioCardEdit": "Изменить",
  "gioCardPhotos": "Готовые фото: {n}",
  "gioCardPhotoFromDesign": "Фото из твоего проекта от {date}",
  "gioCardPhotoFromDesignNoDate": "Фото из твоего проекта",
  "gioCardPhotoFromChat": "Фото из этого чата",
  "gioCardPhotoNew": "Новое фото",
  "gioCardNoPhoto": "Фото пока нет",
  "gioCardChangePhoto": "Изменить",
  "gioCardAddPhoto": "Добавить фото",
  "gioCardUploading": "Загрузка…",
  "gioCardSame": "У тебя уже есть проект в стиле {style} по этому фото ({date}).",
  "gioCardSameView": "Посмотреть",
  "gioCardSameHint": "С тем же запросом результат будет похожим. Чтобы изменить его, добавь запрос выше, напиши Gio в чате или открой в Создании.",
  "gioPickPhoto": "Выбери фото",
  "gioPickUpload": "Загрузи новое фото",
  "gioRunEdit": "Изменить · {n} кредитов",
  "gioRunGenerate": "Создать · {n} кредитов",
  "gioRunWithPhoto": "Добавить фото и создать · {n}/фото",
  "gioOpenInCreate": "Открыть в «Создать»",
  "gioPaintMyself": "Закрасить область самому",
  "gioStarting": "Начинаем…",
  "gioJobMaking": "Создаём дизайн…",
  "gioJobEditing": "Изменяем дизайн…",
  "gioJobNotify": "Можешь выходить — я напишу, когда всё будет готово.",
  "gioJobInvalid": "На фото не похоже на помещение, с которым я могу работать.",
  "gioJobFailed": "Не удалось закончить этот проект.",
  "gioJobRefunded": "Кредиты возвращены.",
  "gioJobDone": "Готово — посмотри",
  "gioJobGone": "Этот дизайн был удалён.",
  "gioAskAboutDesign": "Спросить Gio об этом дизайне",
  "navFeed": "Лента",
  "navMy": "Мои",
  "navAccount": "Настройки",
  "signIn": "Войти",
  "signOut": "Выйти",
  "deleteAccount": "Удалить аккаунт",
  "deleteAccountTitle": "Удалить аккаунт?",
  "deleteAccountWarn": "Это навсегда удалит твой аккаунт и все связанные с ним данные. Это действие нельзя отменить.",
  "deleteAccountItem_designs": "Все твои проекты, изображения и чаты с Gio",
  "deleteAccountItem_profile": "Твой профиль, имя пользователя и сохраненные стили",
  "deleteAccountItem_social": "Комментарии, лайки, подписки и коллекции",
  "deleteAccountItem_credits": "Остаток кредитов, включая купленные, и история подписок",
  "deleteAccountBilling_web": "Твоя активная веб-подписка будет отменена автоматически.",
  "deleteAccountBilling_ios": "Подписка в App Store или Google Play не отменится автоматически — отмени её в настройках подписок своего магазина.",
  "deleteAccountFinal": "Выход из аккаунта произойдет мгновенно, восстановить его будет невозможно.",
  "deleteAccountConfirm": "Удалить аккаунт",
  "deleteAccountSubmitting": "Удаление…",
  "deleteAccountError": "Не удалось удалить аккаунт. Попробуй еще раз.",
  "myDesigns": "Мои дизайны",
  "language": "Язык",
  "support": "Поддержка",
  "terms": "Условиями использования",
  "privacy": "Политикой конфиденциальности",
  "signInTerms": "Войдя, ты соглашаешься с нашими {terms} и {privacy}.",
  "onboardingSkip": "Пропустить",
  "onboardingNext": "Далее",
  "onboardingStart": "Начать",
  "tourTitle": "Обзор archelier",
  "tourCreate": "Начни отсюда. Сфотографируй или загрузи комнату, экстерьер или сад, выбери стиль — и через мгновение дизайн готов.",
  "tourGallery": "Галерея — популярные стили в archelier за неделю. Нажми на любой, чтобы примерить к своему пространству.",
  "tourGio": "Gio — твой дизайнер. Покажи фото и скажи, что хочешь: Gio предложит стили и создаст или изменит дизайн.",
  "tourMy": "Твои дизайны хранятся в «Мои». Исправь любую деталь кистью или описанием, а затем скачай или поделись.",
  "tourStart": "Жми сюда в любое время за новым дизайном. Начнём с одного фото.",
  "tourReplay": "Повторить тур",
  "onboarding": [
    {
      "icon": "photo_camera",
      "title": "Сними, нарисуй или загрузи",
      "desc": "Фото на телефон подходит лучше всего, но archelier также распознает эскизы от руки, чертежи, планы сверху и скриншоты 3D-моделей."
    },
    {
      "icon": "style",
      "title": "19+ стилей, 4 умных режима",
      "desc": "Выбирай готовый стиль, пиши свой запрос, загружай фото-референс или используй режимы «Очистка» и «Планировка» для наведения порядка."
    },
    {
      "icon": "brush",
      "title": "Редактируй только нужную часть",
      "desc": "Не нравится один угол? Просто закрась его кистью и напиши ИИ, что туда добавить. Остальная часть комнаты останется прежней."
    },
    {
      "icon": "auto_awesome",
      "title": "Попробуй прямо сейчас",
      "desc": "Получай бесплатные кредиты каждый день. Загрузи фото, и твой первый дизайн будет готов через минуту."
    }
  ],
  "onboardTabFeedTitle": "Посмотреть ленту",
  "onboardTabFeedDesc": "Посмотри, что создали другие, и найди вдохновение для своего пространства.",
  "onboardTabCreateTitle": "Дизайн с ИИ",
  "onboardTabCreateDesc": "Загрузи фото, набросок или план — ИИ создаст новый дизайн.",
  "onboardTabMyTitle": "Сохраняй и управляй",
  "onboardTabMyDesc": "Твои дизайны будут здесь. Делись ими в ленте или скачивай в любое время.",
  "onboardTabGioTitle": "Спроси Gio",
  "onboardTabGioDesc": "Gio, наш дизайнер интерьера, подбирает стили по фото и может создавать или менять дизайны прямо в чате.",
  "myDesignsTitle": "Мои дизайны",
  "signInToSee": "Войди, чтобы увидеть свои дизайны",
  "signInToSeeDesc": "Твои сохраненные дизайны появятся здесь.",
  "loadingDesigns": "Загрузка дизайнов…",
  "errLoadDesigns": "Не удалось загрузить дизайны. Попробуй еще раз.",
  "retry": "Повторить",
  "noFavorites": "Пока нет избранного.",
  "noDesigns": "Дизайнов пока нет. Создай свой первый!",
  "createDesign": "Создать дизайн",
  "loadMore": "Загрузить еще",
  "loading": "Загрузка…",
  "errDesignNotFound": "Дизайн не найден.",
  "errLoadDesign": "Не удалось загрузить дизайн.",
  "errDeleteDesign": "Не удалось удалить. Попробуй еще раз.",
  "renameTitle": "Переименовать дизайн",
  "renamePlaceholders": [
    "Редизайн гостиной v1",
    "Кухня — светлый вариант",
    "Преображение студии",
    "Спальня, теплые тона",
    "Балкон, план Б",
    "Домашний офис",
    "Черновик интерьера кафе",
    "Передний двор v2"
  ],
  "save": "Сохранить",
  "cancel": "Отмена",
  "deleteTitle": "Удалить дизайн?",
  "deleteDesc": "Это навсегда удалит дизайн и все его изображения. Действие нельзя отменить.",
  "delete": "Удалить",
  "deleting": "Удаление…",
  "postToFeed": "Опубликовать в ленте",
  "postedToFeedTitle": "Опубликовано в ленте",
  "postedToFeedDesc": "Теперь другие пользователи могут видеть и лайкать этот дизайн в ленте.",
  "captionTitle": "Добавить подпись",
  "captionPlaceholder": "Поделись идеей этого дизайна (необязательно)",
  "captionEdit": "Изменить подпись",
  "captionPost": "Опубликовать",
  "captionSave": "Сохранить",
  "captionCancel": "Отмена",
  "viewFeed": "Посмотреть ленту",
  "generationInProgress": "Создаем дизайн твоего пространства…",
  "generationKeepBrowsing": "Полистай пока ленту — мы сообщим, когда все будет готово",
  "generationDone": "Твой дизайн готов!",
  "generationTapToOpen": "Нажми «Открыть», чтобы посмотреть",
  "generationFailedHint": "Кредит не списан. Попробуй еще раз.",
  "open": "Открыть",
  "copy": "Копировать",
  "copied": "Скопировано!",
  "share": "Поделиться",
  "downloadImages": "Скачать ИИ-изображения",
  "download": "Скачать",
  "downloadWatermarkHint": "В правом нижнем углу будет небольшая подпись archelier.",
  "modes": {
    "redesign": "Редизайн",
    "staging": "Стейджинг пустой комнаты"
  },
  "styleUsed": "Использован стиль",
  "customDescLabel": "Своё описание:",
  "additionalReqLabel": "Доп. пожелания:",
  "useStyleAgain": "Использовать стиль снова",
  "feedTitle": "Лента",
  "feedEmpty": "Пока нет публичных дизайнов. Будь первым!",
  "feedSortLatest": "Новые",
  "feedSortPopular": "Популярные",
  "feedFilterAll": "Все",
  "useThisStyle": "Примерить стиль",
  "sourceDesignBanner": "На основе «{name}»",
  "galleryPickBanner": "Создаём в стиле {name}",
  "signInToLike": "Войди, чтобы оценивать",
  "tryApp": "Попробовать archelier",
  "privateTitle": "Этот дизайн приватный",
  "privateDesc": "Автор не сделал этот дизайн публичным.",
  "linkNotFoundTitle": "Ссылка недоступна",
  "linkNotFoundDesc": "Возможно, дизайн удалён или ссылка неполная.",
  "createWithApp": "Создать в archelier",
  "shareViewCTA": "Хочешь обновить свой интерьер?",
  "styles": {
    "modern": {
      "name": "Современный",
      "description": "Четкие линии, нейтральные тона, современный минимализм"
    },
    "scandinavian": {
      "name": "Скандинавский",
      "description": "Светлые тона, природные материалы, уют Севера"
    },
    "ikea": {
      "name": "IKEA",
      "description": "Функциональный, доступный и умный шведский дизайн"
    },
    "japandi": {
      "name": "Джапанди",
      "description": "Японский минимализм и скандинавский уют"
    },
    "industrial": {
      "name": "Индустриальный",
      "description": "Грубые материалы, открытые элементы, эстетика лофта"
    },
    "coastal": {
      "name": "Прибрежный",
      "description": "Свежесть, обилие света, элегантность пляжного дома"
    },
    "classic": {
      "name": "Классика",
      "description": "Элегантность вне времени, дорогие ткани, изящный декор"
    },
    "artdeco": {
      "name": "Арт-деко",
      "description": "Смелая геометрия, золото, роскошь 1920-х годов"
    },
    "midcentury": {
      "name": "Мид-сенчури",
      "description": "Органические формы, теплое дерево, ретро-шарм 50-60-х"
    },
    "maximalist": {
      "name": "Максимализм",
      "description": "Яркие узоры, многослойность, философия «больше значит больше»"
    },
    "vintage": {
      "name": "Винтаж",
      "description": "Ностальгический шарм, антиквариат, теплая ретро-гамма"
    },
    "bohemian": {
      "name": "Бохо",
      "description": "Свободный дух, яркий текстиль, творческая эклектика"
    },
    "tropical": {
      "name": "Тропический",
      "description": "Пышная зелень, ротанг, атмосфера курорта"
    },
    "cottagecore": {
      "name": "Коттеджкор",
      "description": "Романтика английской деревни, цветы, нежная пастель"
    },
    "rustic": {
      "name": "Рустик",
      "description": "Состаренное дерево, камень, тепло загородного дома"
    },
    "wabisabi": {
      "name": "Ваби-саби",
      "description": "Красота несовершенства, грубые текстуры, японский аскетизм"
    },
    "gothic": {
      "name": "Готика",
      "description": "Таинственная драма, темные тона, бархат, изящные силуэты"
    },
    "cyberpunk": {
      "name": "Киберпанк",
      "description": "Неоновый футуризм, хай-тек поверхности, урбан-антиутопия"
    },
    "taisho_romance": {
      "name": "Романтика Тайсё",
      "description": "Япония начала XX века и западный модерн"
    },
    "biophilic": {
      "name": "Биофильный",
      "description": "Растения повсюду, естественный свет, природные текстуры"
    },
    "cozy": {
      "name": "Уютный",
      "description": "Теплый, мягкий, манящий — комфорт в стиле хюгге"
    },
    "gaming": {
      "name": "Гейминг",
      "description": "RGB-подсветка, стильная техника, игровая зона"
    },
    "minimalist": {
      "name": "Минимализм",
      "description": "Минимум деталей, порядок, свободное пространство"
    },
    "mediterranean": {
      "name": "Средиземноморский",
      "description": "Побелка, терракота, арки, натуральный камень"
    },
    "luxury": {
      "name": "Тихая роскошь",
      "description": "Благородные материалы, сдержанные тона, ничего лишнего"
    },
    "dark_academia": {
      "name": "Дарк-академия",
      "description": "Атмосферная библиотека: бордовый, латунь, стопки книг"
    },
    "organic_modern": {
      "name": "Органик-модерн",
      "description": "Современные формы и необработанные материалы"
    },
    "farmhouse": {
      "name": "Фармхаус",
      "description": "Вагонка, глубокая раковина, состаренное дерево, уют"
    },
    "halloween": {
      "name": "Хэллоуин",
      "description": "Тыквы, свечи, таинственная осенняя атмосфера"
    },
    "christmas": {
      "name": "Рождество",
      "description": "Елка, гирлянды, теплый свет, праздничный декор"
    },
    "lunar_new_year": {
      "name": "Лунный Новый год",
      "description": "Красный и золотой, фонарики, традиционные узоры"
    },
    "spring_blossom": {
      "name": "Весеннее цветение",
      "description": "Сакура, пастельные тона, свежий воздушный свет"
    },
    "custom": {
      "name": "Свой стиль",
      "description": "Опиши свое уникальное видение интерьера"
    },
    "reference": {
      "name": "Референс",
      "description": "Повтори цвета, материалы и настроение с фото"
    },
    "floorplan": {
      "name": "Планировка",
      "description": "3D-план или чистовой чертёж по твоей планировке"
    },
    "cleanup": {
      "name": "Уборка",
      "description": "Убери лишнее или полностью освободи комнату"
    },
    "layout": {
      "name": "Планировка",
      "description": "Та же мебель, но удобнее и просторнее"
    }
  },
  "langMismatchNotice": "Этот анализ был создан на языке: {lang}.",
  "pricingTitle": "Тарифы, которые растут вместе с тобой",
  "pricingSubtitle": "Начни бесплатно. Переходи на Pro, если нужно больше генераций.",
  "pricePerMonth": "/ мес.",
  "trialCta": "Попробовать бесплатно на {n} дней",
  "accountPlanFreeTitle": "У тебя бесплатный тариф",
  "accountPlanProTitle": "У тебя тариф Pro",
  "accountPlanTrialTitle": "У тебя Pro — пробный период",
  "proTrialBadge": "Пробный",
  "proTrialDaysLeft": "Осталось {n} дней пробного периода",
  "proTrialIntroTitle": "Получи 2 недели Pro бесплатно",
  "proTrialIntroDesc": "Зарегистрируйся и начни с {n} бесплатных кредитов.",
  "proTrialFeatures": "Затем еще {n} бесплатно каждый день. Без подписок.",
  "welcomeSkip": "Продолжить без аккаунта",
  "landingHeadline": "новый дизайн любой комнаты за секунды.",
  "landingTagline": "Сделай фото, выбери стиль и получи фотореалистичный рендер. Бесплатно каждый день, без подписок.",
  "landingOpenWeb": "Или продолжить в браузере →",
  "landingFeat1": "ИИ-рендеры интерьера",
  "landingFeat2": "Фотореализм",
  "landingFeat3": "50+ стилей",
  "landingFeat4": "Сад и экстерьер",
  "landingFeat5": "Бесплатно каждый день",
  "landingStoreOn": "Загрузите в",
  "landingStoreGet": "Доступно в",
  "lp": {
    "metaTitle": "archelier — ИИ-дизайн интерьера по фото, эскизу или плану",
    "metaDescription": "Сделай фото любой комнаты и получи фотореалистичный дизайн за минуту. 48 стилей для интерьеров, фасадов и садов, 3D-планы, редактирование кистью и ИИ-дизайнер в чате. Бесплатно каждый день.",
    "heroEyebrow": "ИИ-дизайн интерьера",
    "scrollCue": "Как это работает",
    "webCta": "Попробуй бесплатно в браузере",
    "orApp": "Или скачай приложение",
    "qrHint": "Отсканируй камерой телефона. Приложение сообщит, как только дизайн будет готов.",
    "showEyebrow": "До и после",
    "showTitle": "Одно фото. Совершенно новая комната.",
    "showBody": "Реальные результаты в archelier. Перетащи, чтобы сравнить.",
    "before": "До",
    "after": "После",
    "tabRoom": "Гостиная",
    "tabEmpty": "Пустая комната",
    "tabSketch": "Эскиз",
    "tabPlan": "План помещения",
    "tabExterior": "Экстерьер",
    "capRoom": "Рустик — те же кухня и гостиная, но более уютные и тёплые.",
    "capEmpty": "Скандинавский — пустая комната с мебелью.",
    "capSketch": "Джапанди — набросок от руки, превращённый в реальный интерьер.",
    "capPlan": "Режим планировки — 2D-план, превращённый в 3D-модель всего дома.",
    "capExterior": "Минимализм — обновлённый витринный фасад.",
    "howEyebrow": "Как это работает",
    "howTitle": "Три шага и около минуты.",
    "how1Title": "Сделай фото",
    "how1Body": "Любая комната как есть — или эскиз, план и 3D-скриншот. До 3 ракурсов одной комнаты.",
    "how2Title": "Выбери стиль",
    "how2Body": "Выбери один из 48 стилей, опиши свой в одном предложении или загрузи понравившееся фото.",
    "how3Title": "Получи дизайн",
    "how3Body": "Фотореалистичный рендер твоего пространства со списком мебели, палитрой и схемой освещения.",
    "stylesEyebrow": "Стили",
    "stylesTitle": "48 стилей для трёх типов пространств.",
    "stylesBody": "28 для интерьеров, 11 для экстерьеров, 9 для садов — плюс сезонные образы к праздникам и весне.",
    "stylesInterior": "Интерьер",
    "stylesExterior": "Экстерьер",
    "stylesGarden": "Сад",
    "stylesCta": "Смотреть галерею стилей",
    "modesEyebrow": "Больше, чем стили",
    "modesTitle": "Ещё 5 способов изменить пространство.",
    "modeCustomTitle": "Свой стиль",
    "modeCustomBody": "Опиши нужный вид предложением и сохрани на будущее.",
    "modeReferenceTitle": "Референс",
    "modeReferenceBody": "Загрузи понравившееся фото и заимствуй настроение, материалы и палитру без планировки.",
    "modeCleanupTitle": "Очистка",
    "modeCleanupBody": "Убери лишнее и посмотри на пустую комнату.",
    "modeLayoutTitle": "Расстановка",
    "modeLayoutBody": "Переставь имеющуюся мебель вместо того, чтобы менять её.",
    "modePlanTitle": "Планировка",
    "modePlanBody": "Преврати 2D-план в 3D-вид всего дома или набросок — в аккуратный чертёж.",
    "editEyebrow": "Редактирование кистью",
    "editTitle": "Меняй детали по одной.",
    "editBody": "Хочешь заменить только диван? Обведи его и напиши, что нужно. archelier перерисует только эту зону, не трогая всё остальное — то же самое с цветом стен, коврами, светом и декором.",
    "editPrompt": "Винтажный кожаный диван",
    "shopTitle": "Покупай то, что видишь.",
    "shopBody": "К каждому дизайну прилагается список мебели, палитра и схема света, а к предметам — ссылки на поиск похожих вещей.",
    "gioEyebrow": "Gio",
    "gioTitle": "Обсуди проект с дизайнером.",
    "gioBody": "Gio — твой ИИ-дизайнер на отдельной вкладке. Отправь фото комнаты, ссылку на интерьер или свой проект. Gio предложит решение и создаст или отредактирует дизайн прямо в чате.",
    "gioRole": "Дизайнер интерьера",
    "gioUser": "Это моя кухня-столовая. Выглядит неуютно и холодновато. Есть идеи?",
    "gioReply": "Давай добавим тёплое дерево, мягкий текстиль и приглушённый свет вместо строгих поверхностей. Вот вариант:",
    "gioCardTitle": "Уют джапанди",
    "gioCardBody": "Натуральный дуб и фактурная штукатурка сразу сделают пространство теплее.",
    "gioCardAction": "Создать",
    "priceEyebrow": "Тарифы",
    "priceTitle": "Бесплатно каждый день. Без подписки.",
    "price1": "Бесплатные дизайны каждый день, обновление в местную полночь",
    "price2": "Бонус при создании аккаунта",
    "price3": "Пригласи друга, и вы оба получите больше",
    "price4": "Нужно больше? Пополни баланс пакетом кредитов",
    "privacyTitle": "Твои фото остаются твоими.",
    "privacyBody": "Твои фото, промпты и дизайны не используются для обучения ИИ или рекламы. Твои дизайны остаются приватными, пока ты не поделишься ими.",
    "faqTitle": "Вопросы",
    "faq1Q": "Что такое archelier?",
    "faq1A": "archelier (Architect + Atelier) — это ИИ-приложение для дизайна интерьеров на телефоне и в веб-версии. Наведи камеру на комнату, выбери стиль и получи фотореалистичный дизайн своего пространства с названиями и ссылками на всю мебель. Подходит для интерьеров, экстерьеров и садов.",
    "faq2Q": "Как это работает?",
    "faq2A": "Сделай фото комнаты или загрузи эскиз, план или 3D-скриншот. Выбери один из 48 стилей, опиши свой или загрузи фото для примера. Примерно за минуту ты получишь фотореалистичный рендер своего пространства, список мебели, палитру цветов и план освещения.",
    "faq3Q": "archelier — это бесплатно?",
    "faq3A": "Да. Подписки нет. Каждый получает бесплатные дизайны каждый день (обновляются в полночь), а также бонусы за регистрацию и приглашение друзей. Если нужно больше, можно купить пакет кредитов.",
    "faq4Q": "Можно ли превратить план помещения в 3D-рендер?",
    "faq4A": "Да. Режим «План помещения» превращает 2D-план в 3D-вид всего дома в выбранном стиле. Также он может превратить набросок от руки или нечеткий план в чистый чертеж или цветной план.",
    "faq5Q": "Можно ли скопировать стиль с понравившегося фото?",
    "faq5A": "Да. Выбери стиль «Референс» и загрузи фото для вдохновения. archelier перенесет настроение, материалы и палитру на твою комнату, не меняя её планировку.",
    "faq6Q": "Можно ли изменить только одну деталь дизайна?",
    "faq6A": "Да. Обведи нужную область — диван, ковер, стену — и напиши, что ты хочешь вместо этого. Изменится только выделенная часть, остальная комната останется прежней.",
    "faq7Q": "Кто такой Gio?",
    "faq7A": "Gio — это ИИ-дизайнер пространств в archelier. Отправь ему фото своей комнаты, картинку или ссылку на понравившийся интерьер или один из своих дизайнов. Gio предложит идею, создаст или отредактирует дизайн прямо в чате и ответит на вопросы про цвета, бюджет и освещение.",
    "faq8Q": "Используются ли мои фото для обучения ИИ?",
    "faq8A": "Нет. archelier не использует твои фото, промпты или дизайны для обучения ИИ или рекламы. Дизайны доступны только в твоем аккаунте, пока ты не поделишься ими.",
    "faq9Q": "Где можно использовать archelier?",
    "faq9A": "В App Store, Google Play и в веб-версии на archelier.co. Твой аккаунт и дизайны синхронизируются на всех устройствах. archelier доступен на 11 языках.",
    "ctaTitle": "Преобрази свою комнату уже сегодня.",
    "ctaBody": "На телефоне и в веб-версии. Твои дизайны синхронизируются везде.",
    "langLabel": "Язык"
  },
  "upgradeToPro": "Перейти на Pro",
  "creditsPerMonth": "{n} кредитов в месяц",
  "planFreeName": "Free",
  "planFreeTagline": "Попробуй archelier с несколькими проектами в месяц.",
  "planProName": "Pro",
  "planProTagline": "Для тех, кто часто создает дизайн и ценит качество.",
  "planStudioName": "Студия",
  "planStudioTagline": "Для профи, команд и коммерческой работы.",
  "planFeatWatermark": "С водяным знаком «archelier»",
  "planFeatNoWatermark": "Без водяных знаков на дизайнах",
  "planFeatUnlimited": "Безлимитная генерация дизайнов",
  "planFeatUnlimitedChat": "Безлимитный ИИ-чат для дизайна (бесплатно: 3 запроса)",
  "planFeatUnlimitedEdit": "Безлимитное редактирование зон",
  "planFeatFeed": "Публикация в ленту",
  "planFeatEverythingPro": "Всё, что есть в Pro",
  "planFeatCommercial": "Коммерческие права на использование",
  "planFeatApiAccess": "Доступ к API (скоро)",
  "planCtaSubscribe": "Подписаться",
  "planCtaCurrent": "Твой текущий тариф",
  "planPopular": "Популярно",
  "signInToSubscribe": "Войди, чтобы подписаться",
  "signInToBuy": "Войди, чтобы купить",
  "trialNote": "{n} дней бесплатно",
  "creditPacksTitle": "Или купи пакеты кредитов",
  "creditPacksSubtitle": "Разовая покупка, без подписки.",
  "packStarterName": "Стартовый пакет",
  "packStandardName": "Стандартный пакет",
  "packProName": "Про-пакет",
  "packCreditsAmount": "{n} кредитов",
  "packCtaBuy": "Купить",
  "pricingFootnote": "Цены в USD. Налоги при оплате. Отмена в любое время.",
  "errBillingGeneric": "Что-то пошло не так. Пожалуйста, попробуй еще раз.",
  "accountTitle": "Настройки",
  "accountPlanSection": "Подписка",
  "accountCreditsSection": "Кредиты",
  "accountCreditsDesc": "Кредиты списываются за генерацию дизайнов. Пополняй в любое время.",
  "viewPlans": "Посмотреть тарифы",
  "changePlan": "Сменить тариф",
  "manageBilling": "Управление оплатой",
  "manageBillingWebHint": "Если подписка оформлена на сайте, управляй ей на archelier.co.",
  "buyCreditPack": "Купить пакет кредитов",
  "subRenewsAt": "Продление {date}",
  "subEndsAt": "Заканчивается {date}",
  "trialEndsAt": "Пробный период до {date} — далее $9.99/мес.",
  "trialCancelEndsAt": "Пробный период до {date} — подписка не продлится",
  "subStatus_past_due": "Просрочен платеж — пожалуйста, обнови способ оплаты.",
  "subStatus_canceled": "Подписка отменена.",
  "subStatus_unpaid": "Подписка не оплачена.",
  "subStatus_trialing": "Пробный период активен.",
  "account": "Аккаунт",
  "pricing": "Цены",
  "upgrade": "Улучшить",
  "inviteTitle": "Приглашай друзей и получай кредиты",
  "inviteSubtitle": "Когда друг зарегистрируется по твоей ссылке, ты получишь +{inviter} кредитов, а он — +{invitee}.",
  "inviteFriends": "Пригласить друзей",
  "inviteSignInHint": "Войди, чтобы получить личную ссылку.",
  "yourReferralCode": "Твоя ссылка-приглашение",
  "inviteCodeLoading": "Создаем твою ссылку…",
  "inviteLinkHint": "Новые пользователи по твоей ссылке получат +{n} кредитов.",
  "copyLink": "Скопировать ссылку",
  "shareLink": "Поделиться ссылкой",
  "inviteShareText": "Обнови свой интерьер с помощью ИИ в archelier. Переходи по ссылке и получи +{n} бесплатных кредитов.",
  "redeemTitle": "Есть промокод?",
  "redeemDesc": "Введи пригласительный код друга или промокод, чтобы получить бонусы.",
  "copyCode": "Скопировать код",
  "errRefSelf": "Нельзя использовать свой собственный код.",
  "landingInviteTitle": "Друг пригласил тебя — вы оба получите +{n} кредитов.",
  "landingInviteAutoIos": "Установи приложение, затем снова нажми на эту ссылку-приглашение — приложение откроется, а бонус зачислится при регистрации.",
  "landingInviteAutoAndroid": "Установи приложение через Google Play ниже и зарегистрируйся — бонус зачислится автоматически. Если этого не произошло, введи этот код в Настройки → Пригласить друзей.",
  "landingInviteDesktop": "Зарегистрируйся здесь, и бонус зачислится сразу. Чтобы получить его в приложении, отсканируй QR-код и следуй инструкциям на телефоне.",
  "promoTitle": "Есть промокод?",
  "promoDesc": "Введи промокод, чтобы получить бонусные кредиты.",
  "promoPlaceholder": "напр. LAUNCH2026",
  "promoRedeem": "Применить",
  "promoSuccess": "Активировано — {n} кредитов добавлено на твой счет.",
  "errPromoInvalid": "Неверный код.",
  "errPromoExpired": "Срок действия кода истек.",
  "errPromoMaxed": "Лимит использований кода исчерпан.",
  "errPromoUsed": "Этот код уже активирован тобой.",
  "errPromoUserInit": "Обнови и попробуй еще раз.",
  "errPromoGeneric": "Не удалось применить код. Попробуй еще раз.",
  "reportThisDesign": "Пожаловаться на дизайн",
  "reportShort": "Пожаловаться",
  "reportTitle": "Пожаловаться на дизайн",
  "reportDesc": "Что не так с этим дизайном? Жалобу увидят только модераторы.",
  "reportReason_spam": "Спам или реклама",
  "reportReason_nsfw": "Непристойный или неуместный контент",
  "reportReason_copyright": "Нарушение авторских прав",
  "reportReason_other": "Другое",
  "reportNotePlaceholder": "Добавь детали (необязательно, до 500 симв.)",
  "reportSubmit": "Отправить жалобу",
  "reportSubmitting": "Отправка…",
  "reportSignInHint": "Войди в аккаунт, чтобы отправить жалобу.",
  "reportThanks": "Жалоба принята",
  "reportThanksDesc": "Мы проверим это и примем меры. Спасибо за сигнал.",
  "errReportGeneric": "Не удалось отправить жалобу. Попробуй позже.",
  "blockUser": "Заблокировать пользователя",
  "unblockUser": "Разблокировать",
  "blockShort": "Блокировать",
  "blockConfirm": "Заблокировать @{handle}? Ты не увидишь их дизайны и активность, а они — твои.",
  "blockedUsersMenu": "Заблокированные",
  "blockedUsersTitle": "Заблокированные пользователи",
  "blockedUsersDesc": "Заблокированные тобой пользователи. Их дизайны скрыты из твоей ленты.",
  "blockedUsersEmpty": "Ты никого не заблокировал.",
  "profileBlocked": "Этот пользователь заблокирован.",
  "profileBlockedAction": "Разблокируй, чтобы снова видеть их дизайны.",
  "errBlockGeneric": "Не удалось обновить статус. Попробуй еще раз.",
  "errBlockedCustomCommand": "Твой запрос содержит недопустимые слова.",
  "moderationAutoUnlisted": "Этот дизайн скрыт из общей ленты модерацией. Если это ошибка, свяжись с администрацией.",
  "promptLang": "Russian"
};
